"use strict";

(function ($) {
    // Only for this page template
    if ( document.body.classList.contains('product-template-page-product-kvadra-nau') ) {

        /* color picker changes the image of the laptop
        -------------------------------------------------------------------*/
        const nauColorsSection = $( '.section-nau-colors' );

        nauColorsSection.on( 'click', '.product-colors__btn', function() {
            const newImgColor         = this.getAttribute( 'data-color' ),
                  $imgTag          = $( this ).parents( '.product-colors' ).find( '.product-colors__img' ),
                  $currentImgColor = $imgTag.attr( 'data-color' );

            $imgTag.parent().children().each( function() {
                let attrName = 'src';
                if ( this.localName === 'source' ) {
                    attrName = 'srcset';
                }
                this.setAttribute( attrName, this.getAttribute( attrName ).replace( $currentImgColor, newImgColor ) );
                $imgTag.attr( 'data-color', newImgColor );

            } );

            // $( this ).parents( '.product-colors' ).find( '.product-colors__img' ).attr( 'src', imgColor );
            for (let btn of this.parentElement.children) {
                btn.classList.remove( 'active' );
            }
            this.classList.add( 'active' );
        } );

    } // IF this page
})(jQuery);

